import { render, staticRenderFns } from "./ScreensaversText.vue?vue&type=template&id=3b545b96&scoped=true"
import script from "./ScreensaversText.vue?vue&type=script&lang=js"
export * from "./ScreensaversText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b545b96",
  null
  
)

export default component.exports